import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CreateCardOnFileFormModalComponent } from '../../../../modules/user/profile/cards-on-file/components/create-card-on-file-form-modal/create-card-on-file-form-modal.component';
import { DeleteCardOnFileConfirmationModalComponent } from '../../../../modules/user/profile/cards-on-file/components/delete-card-on-file-confirmation-modal/delete-card-on-file-confirmation-modal.component';
import { EditCardOnFileFormModalComponent } from '../../../../modules/user/profile/cards-on-file/components/edit-card-on-file-form-modal/edit-card-on-file-form-modal.component';
import { CreditCardSummary } from '../../../models/commerce/cards-on-file/credit-card-summary';

@Injectable({ providedIn: 'root' })
export class CreditCardDialogService {
    constructor(private readonly dialog: MatDialog) {}

    openEditCardDialog(
        cardOnFileId: number,
        userId: number,
        cardsOnFile: CreditCardSummary[],
    ): Observable<boolean> {
        return this.dialog
            .open(EditCardOnFileFormModalComponent, {
                width: '900px',
                disableClose: true,
                data: { cardOnFileId, userId, cardsOnFile },
            })
            .afterClosed();
    }

    openCreateCardDialog(
        userId: number,
        orderId: number | null,
        cardsOnFile: CreditCardSummary[],
    ): Observable<CreditCardSummary | null> {
        return this.dialog
            .open(CreateCardOnFileFormModalComponent, {
                width: '900px',
                disableClose: true,
                data: { userId, orderId, cardsOnFile },
            })
            .afterClosed();
    }

    openDeleteCardDialog(cardOnFileId: number): Observable<boolean> {
        return this.dialog
            .open(DeleteCardOnFileConfirmationModalComponent, {
                width: '450px',
                disableClose: true,
                data: { cardOnFileId },
            })
            .afterClosed();
    }
}
